var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDesignationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.78312 0H0.965823C0.431578 0 0 0.431602 0 0.965823V12.0342C0 12.5671 0.431602 13 0.965823 13H8.78451C9.31748 13 9.75034 12.5684 9.75034 12.0342L9.75025 0.965823C9.74898 0.431579 9.31739 0 8.78315 0L8.78312 0ZM5.23193 10.33H2.08626V9.2472H5.23193V10.33ZM7.57309 7.04132H2.0851V5.95854H7.57309V7.04132ZM7.57309 3.7515H2.0851V2.66872H7.57309V3.7515Z",
    fill: "#ADADAD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignationIcon);
export default __webpack_public_path__ + "static/media/designation_icon.973adba9.svg";
export { ForwardRef as ReactComponent };